module.exports = __webpack_public_path__ + "img/thumbnail_Gharial_j_normal.531f957d.png";